
export const payReducer = (state = [], action) => {

    switch (action.type) {
        case '[PAY] Load list':
            return {
                ...state,
                pays: action.payload
            }

        case '[PAY] set detail':
            return {
                ...state,
                detailPay: action.payload
            }

        default:
            return state
    }


}